<template>
  <div>
    <div v-if="isScreenTooSmall" class="screen-size-blocker">
      <div class="blocker-content">
        <div><img src="formdata-logo-calig-dark.svg" style="max-width:70px;max-height:60px;"></div>
        <h2>Device Not Supported</h2>
        <p>You need a screen wider than 1071 pixels to use this application.</p>
      </div>
    </div>
    <div v-else-if="isWindowTooSmall" class="window-size-blocker">
      <div class="blocker-content">
        <div><img src="formdata-logo-calig-dark.svg" style="max-width:70px;max-height:60px;"></div>
        <h2>Window Too Small</h2>
        <p>Please maximize your browser window to use this application.</p>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted } from 'vue'

export default defineComponent({
  name: 'App',

  setup() {
    const minWidth = 1071
    const isScreenTooSmall = ref(false)
    const isWindowTooSmall = ref(false)
    const windowWarningDismissed = ref(false)

    const checkScreenSize = () => {
      // Check if the screen itself is too small
      isScreenTooSmall.value = window.screen.width < minWidth

      // Only check window size if screen is large enough and warning not dismissed
      if (!isScreenTooSmall.value && !windowWarningDismissed.value) {
        isWindowTooSmall.value = window.innerWidth < minWidth
      }
    }

    const dismissWindowWarning = () => {
      windowWarningDismissed.value = true
      isWindowTooSmall.value = false
    }

    onMounted(() => {
      checkScreenSize()
      window.addEventListener('resize', checkScreenSize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenSize)
    })

    return {
      isScreenTooSmall,
      isWindowTooSmall,
      dismissWindowWarning
    }
  }
})
</script>

<style lang="scss">
.screen-size-blocker, .window-size-blocker {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  text-align: center;
}

.screen-size-blocker {
  background-color: #263238; /* blue-grey-10 in Quasar */
  color: white;
}

.window-size-blocker {
  background-color: rgba(38, 50, 56, 0.9); /* blue-grey-10 with opacity */
  color: white;
  backdrop-filter: blur(4px);
}

.blocker-content {
  max-width: 90%;
  padding: 2rem;
}
</style>
